import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import { Button, Col, Container, Input, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import {
    Accounting,
    AccountingListParams,
    ApiAccountingInvoiced,
    ApiAccountingList,
    ApiCourseProvidersAutoSuggest,
    CourseProviderAutoSuggestListResult,
    CourseProvidersAutoSuggestResult,
    ServerResponse,
} from '../../api';
import Footer from '../../components/footer/Footer';
import HeaderLoggedIn from '../../components/headerLoggedIn/HeaderLoggedIn';
import LiveSearchInput from '../../components/liveSearchInput/LiveSearchInput';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import Paging from '../../components/paging/Paging';
import { IThConfig, SortableTh } from '../../components/sortableTh/SortableTh';
import { TableBox } from '../../components/tableBox/TableBox';
import { IEmptyProps, ISortIcon } from '../../constants';
import { InvoiceState } from '../cpBookings/CPBookings';
import './AdminAllAccounting.css';

interface IState {
    listData: Accounting[];
    checkeBoxArray: boolean[];
    loading: boolean;
    searchParams: AccountingListParams;
    serverResponse?: ServerResponse;
    totalCount: number;
    sortIcon: ISortIcon[];
}

export default class AdminAllAccounting extends React.PureComponent<IEmptyProps, IState> {
    private renderTHeadLineArrays: IThConfig[] = [
        { sortField: 'courseProviderName', name: 'Kursanbieter', width: '20%' },
        { sortField: 'appointments', name: 'Termine', width: '15%' },
        { sortField: 'bookings', name: 'Buchungsanfragen', width: '20%' },
        { sortField: 'commissionSum', name: 'Summe Provision', width: '20%' },
        { sortField: 'invoiceDate', name: 'Datum', width: '12%' },
        { sortField: 'invoiceState', name: 'Aktion', width: '12%' },
    ];
    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            checkeBoxArray: [],
            listData: [],
            loading: true,
            searchParams: {
                CourseProviderId: '',
                Descending: false,
                Offset: 0,
                PageSize: 50,
                Search: '',
                Sort: 'invoiceDate',
            },
            serverResponse: undefined,
            sortIcon: [],
            totalCount: 0,
        };
    }

    public componentDidMount() {
        this.searchCourseProviders();
    }

    public render() {
        const renderTHeadLine = (
            <tr>
                <th>
                    <Input
                        name="allCheckedIn"
                        type="checkbox"
                        checked={this.state.checkeBoxArray.every(this.ifAllArraySame)}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const checkMe: boolean[] = this.state.checkeBoxArray;
                            checkMe.map((bool: boolean, i: number) => {
                                checkMe[i] = e.currentTarget.checked;
                            });
                            this.setState({ checkeBoxArray: [...checkMe] });
                        }}
                    />
                </th>
                {this.renderTHeadLineArrays.map((str: IThConfig, index: number) => {
                    return (
                        <SortableTh
                            key={str.name}
                            index={index}
                            sortIcon={this.state.sortIcon[index]}
                            sortField={str.sortField}
                            onClickSorting={this.onClickSorting}
                            widthStyle={str.width}
                            name={str.name}
                        />
                    );
                })}
            </tr>
        );

        return (
            <NetworkOverlay loading={this.state.loading} serverResponse={this.state.serverResponse}>
                <HeaderLoggedIn />
                <Container>
                    <Row>
                        <Col className={'searchLine'}>
                            <LiveSearchInput
                                placeholder={TR.adminAllAccounting_search_course_provider}
                                onFetchRequest={(search, callback) => {
                                    ApiCourseProvidersAutoSuggest(
                                        {
                                            Search: search,
                                        },
                                        (sr: ServerResponse & { Data: CourseProviderAutoSuggestListResult }) => {
                                            if (sr.OK) {
                                                callback(sr.Data.CourseProviders);
                                            } else {
                                                callback([]);
                                            }
                                        }
                                    );
                                }}
                                onClear={() => {
                                    this.changeValue('CourseProviderId', '', true, true);
                                }}
                                renderSuggestion={(suggestion: CourseProvidersAutoSuggestResult) => {
                                    return <span>{suggestion.Name}</span>;
                                }}
                                getSuggestionValue={(suggestion: CourseProvidersAutoSuggestResult) => {
                                    this.changeValue('CourseProviderId', suggestion.ID, true, true);
                                    return suggestion.Name;
                                }}
                            />
                        </Col>
                    </Row>
                    {!this.state.loading && (
                        <Row className="mt-5">
                            <Col>
                                <TableBox
                                    listData={this.state.listData}
                                    renderTHeadLine={renderTHeadLine}
                                    renderTBodyLine={this.renderTBodyLine}
                                />
                                <Row className="mb-1">
                                    <Col md={2}>
                                        {this.state.listData ? (
                                            <Button
                                                size="sm"
                                                color="danger"
                                                onClick={() => this.InvoiceAllCHeckedCourseProvider()}
                                            >
                                                <span>{TR.adminAllAccounting_invoice_selected}</span>
                                            </Button>
                                        ) : null}
                                    </Col>
                                </Row>
                                <Paging
                                    totalCount={this.state.totalCount}
                                    pageSize={this.state.searchParams.PageSize}
                                    offset={this.state.searchParams.Offset}
                                    changeValue={this.changeValue}
                                />
                            </Col>
                        </Row>
                    )}
                </Container>
                <Footer />
            </NetworkOverlay>
        );
    }

    private ifAllArraySame = (bool: boolean) => {
        if (bool) {
            return true;
        } else {
            return false;
        }
    };

    private changeValue = (
        fieldName: string,
        value: string | boolean | number,
        reload: boolean = false,
        resetPaging: boolean = false
    ) => {
        const newParams = { ...this.state.searchParams };
        // @ts-ignore
        newParams[fieldName] = value;
        if (resetPaging) {
            newParams.Offset = 0;
        }
        if (reload) {
            this.setState({ searchParams: newParams }, this.searchCourseProviders);
        } else {
            this.setState({ searchParams: newParams });
        }
    };

    private searchCourseProviders = () => {
        ApiAccountingList({ ...this.state.searchParams }, (sr) => {
            if (sr.OK) {
                this.setState(
                    {
                        listData: sr.Data ? sr.Data.Lines : [],
                        loading: false,
                        serverResponse: sr,
                        totalCount: sr.Data ? sr.Data.Count : 0,
                    },
                    () => {
                        const mySortIcon = this.state.sortIcon;
                        this.renderTHeadLineArrays.map(() => {
                            mySortIcon.push(0);
                        });
                        const checkedArray: boolean[] = [];
                        if (this.state.listData) {
                            this.state.listData.map((str: Accounting) => {
                                checkedArray.push(false);
                            });
                        }
                        this.setState({ sortIcon: [...mySortIcon], checkeBoxArray: [...checkedArray] });
                    }
                );
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };

    private InvoiceCourseProvider = (id: string) => {
        this.setState({ loading: true });
        ApiAccountingInvoiced({ ...{ ID: id } }, (sr) => {
            if (sr.OK) {
                this.searchCourseProviders();
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };

    private InvoiceAllCHeckedCourseProvider = () => {
        const myIDArrays: string[] = [];
        this.state.listData.map((str: Accounting, i: number) => {
            if (this.state.checkeBoxArray[i]) {
                myIDArrays.push(str.ID);
            }
        });
        myIDArrays.map((sr: string) => {
            this.InvoiceCourseProvider(sr);
        });
    };

    private renderTBodyLine = (value: Accounting, index: number) => {
        const isChecked = this.state.checkeBoxArray[index] != null && this.state.checkeBoxArray[index];
        return (
            <tr key={value.CourseProviderName + (index + 1)}>
                <td>
                    <Input
                        name={`checkbox${index}`}
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const checkMe: boolean[] = this.state.checkeBoxArray;
                            checkMe[index] = e.currentTarget.checked;
                            this.setState({ checkeBoxArray: [...checkMe] });
                        }}
                    />
                </td>
                <td>
                    <a href={'#/acdetails/' + value.CourseProviderID + '/' + value.Month}>{value.CourseProviderName}</a>
                </td>
                <td>{value.Appointments}</td>
                <td>{value.Bookings}</td>
                <td>
                    {value.CommissionSum.toLocaleString('de-DE', {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                        useGrouping: false,
                    })}
                    &nbsp;€
                </td>
                <td>{moment(value.InvoiceDate).format('DD.MM.YYYY')}</td>
                <td>
                    {value.InvoiceState === InvoiceState.Invoiced ? (
                        <span>&nbsp;{TR.adminAllAccounting_invoiced}</span>
                    ) : (
                        <Button
                            size="sm"
                            color="danger"
                            onClick={() => {
                                this.InvoiceCourseProvider(value.ID);
                            }}
                        >
                            <span>{TR.adminAllAccounting_invoice}</span>
                        </Button>
                    )}
                </td>
            </tr>
        );
    };

    private onClickSorting = (sortField: string, index: number, sortIcon: ISortIcon) => {
        this.changeValue('Sort', sortField, true);
        const mySortIcon: ISortIcon[] = [];
        this.state.sortIcon.map(() => mySortIcon.push(ISortIcon.Sort));
        mySortIcon[index] = sortIcon;
        if (sortIcon === ISortIcon.Sort) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
        if (sortIcon === ISortIcon.SortUp) {
            mySortIcon[index] = ISortIcon.SortDown;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', true, true);
            });
        }
        if (sortIcon === ISortIcon.SortDown) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/views/adminAllAccounting/AdminAllAccounting.tsx